import MUIAccountCircle from '@mui/icons-material/AccountCircle'

export const AccountCircle = MUIAccountCircle
